<nav class="cabecera">
    <a class="regresar"><i class="fa fa-chevron-left" (click)="regresar()"></i></a>
    <h5>{{ title }}</h5>
    <a data-target="slide-out" class="sidenav-trigger"><i class="fa fa-bars"></i></a>
</nav>
<div class="container">
    <div class="row">
        <div class="col s12">
            <div *ngFor="let lote of lotes;" class="card horizontal" (click)="goToCorral(lote.idLote)">
                <div class="col s3">
                  <p class="icon-grande">
                        <i class="fa fa-institution"></i>
                    </p>
                </div>
                <div class="col s9">
                    <p>Código:<br>
                        <strong *ngIf="user.TipoPesaje != 2">{{ lote.lote }}</strong>
                        <strong *ngIf="user.TipoPesaje == 2">{{ lote.lote_str }}</strong><br>
                        Fecha de Creación<br>
                        {{ lote.FecinicioProd | date : 'yyyy-MM-dd hh:mmm' }}
                    </p>
                </div>
            </div>
            <div *ngIf="lotes.length == 0">
                <p>&nbsp;</p>
                <p class="text-center">No se encontraron lotes</p>
            </div>
        </div>
    </div>
</div>
<div id="modalSincronizacionLocalServidor" class="modal">
    <div class="modal-content">
        <h4>Sincronización de Semanas</h4>
        <hr>
        <div>
            <span style="display:flex; flex-direction: row; justify-content: space-between;
            align-items: center;" *ngFor="let fs of resource.falta_subir;">Semana {{fs.semana}}
                <i class="fa fa-spinner fa-spin" *ngIf="fs.state == null"></i>
                <i class="fa fa-times-circle" style="color: red;"  *ngIf="!fs.state && fs.state != null"></i>
                <i class="fa fa-check-circle" style="color: green;" *ngIf="fs.state"></i>
            </span>
        </div>
    </div>
</div>
